export default __webpack_public_path__ + "static/media/icon_cloud_vector.12334533.svg";